<template>
	<div class="report_detail_text">
		<div class="text_content" v-for="(item,index) in list" :key="index">{{ item }}</div>
	</div>
</template>
<script>
export default {
    name: 'reportDetailText',
    props: {
        list: {
            type: Array,
            default: () => []
        }
    }
}
</script>
<style lang="less" scoped>
.report_detail_text {
	.text_content {
		font-size: 26px;
		color: #1f2329;
		margin-bottom: 12px;
		&:last-child {
			margin-bottom: 0;
		}
	}
}
</style>